__webpack_require__.p = "/alltools/";